import { useState } from "react";
import { Tooltip } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { FluentInput } from "../../../../../components/FluentUI/Fluent-Input";
import DownloadDataModal from "../../../dynamic-fields/download-data-modal/download-data-modal";
import { GetTechStafferHistoricalExcelExport, GetTechStafferRawExcelExport } from "../../../../../services/api/dashboard-api";

const TechStafferBankerTimeLogHeader = ({
  isStaffer,
  resetDataState,
  memberState,
  searchValue,
  onSearchChange,
  expandWidget,
  expandClass,
  onExport,
  subTitle = "Technology",
}) => {
  const [viewDataModal, setViewDataModal] = useState(false);

  const hasAnyFilter =
    memberState.filter &&
    Array.isArray(memberState.filter.filters) &&
    memberState.filter.filters.length > 0;
  const canReset = memberState.sort.length > 0 || hasAnyFilter || !!searchValue?.trim();

  return (
    <>
      <div className="widget-header" data-testid="banker-time-log-header">
        <div className="header-left">
          <div className="main-title-badge-row">
            <div className="main-title">Banker Time Log</div>
            <FluentInput
              placeholder="Search"
              type="text"
              value={searchValue}
              onChange={onSearchChange}
              componentStyle="search-input"
              contentBefore={<FluentUiIcon name="SearchRegular" size={14} />}
              noKey
            />
          </div>
          <div className="sub-title">{subTitle}</div>
        </div>
        <div className="header-right">
          <Tooltip content="Reset Filters and Sorting">
            <span>
              <FluentButton
                appearance="secondaryWithOutline"
                icon={
                  <FluentUiIcon
                    name="ArrowResetRegular"
                    color={canReset ? "#0F6CBD" : "#A0A0A0"}
                    size={20}
                    disabled={!canReset}
                  />
                }
                disabled={!canReset}
                onClick={resetDataState}
              />
            </span>
          </Tooltip>
          <Tooltip content="Export Data">
            <span>
              <FluentButton
                appearance="secondaryWithOutline"
                icon={
                  <FluentUiIcon
                    name="ArrowDownloadRegular"
                    color="#0F6CBD"
                    size={20}
                  />
                }
                onClick={onExport}
              />
            </span>
          </Tooltip>
          <Tooltip content="Expand Widget">
            <span>
              <FluentButton
                appearance="secondaryWithOutline"
                icon={
                  <FluentUiIcon
                    name={
                      expandClass === "widgetExpanded"
                        ? "FullScreenMinimizeFilled"
                        : "FullScreenMaximizeFilled"
                    }
                    color="#0F6CBD"
                    size={20}
                  />
                }
                onClick={expandWidget}
              />
            </span>
          </Tooltip>
          {isStaffer && (
            <FluentButton
              icon={
                <FluentUiIcon
                  name="CalendarArrowCounterclockwiseRegular"
                  color="#0F6CBD"
                  size={20}
                />
              }
              text="Historical Data"
              onClick={() => setViewDataModal(true)}
            />
          )}
        </div>
      </div>
      {viewDataModal && (
        <DownloadDataModal
          open={viewDataModal}
          OnCancel={() => setViewDataModal(false)}
          OnDownloadData={async (startDate, endDate, selectedProjectCategories, selectedData) => {
            const payload = {
              startDate,
              endDate,
              categories: selectedProjectCategories.map((cat) => cat.Id),
            };
            const isHistorical =
              selectedData === "<GIB/Technology> Project and Member Time Log Summary";
            const exportFn = isHistorical
              ? GetTechStafferHistoricalExcelExport
              : GetTechStafferRawExcelExport;
            const res = await exportFn(payload);
            if (res.status === 200) {
              const link = document.createElement("a");
              link.href = res.data;
              link.download = isHistorical ? "historicalData.xlsx" : "rawData.xlsx";
              link.click();
            }
            return res;
          }}
        />
      )}
    </>
  );
};

TechStafferBankerTimeLogHeader.propTypes = {
  isStaffer: PropTypes.bool,
  resetDataState: PropTypes.func.isRequired,
  memberState: PropTypes.shape({
    filter: PropTypes.object,
    sort: PropTypes.array,
  }).isRequired,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  expandWidget: PropTypes.func.isRequired,
  expandClass: PropTypes.string,
  onExport: PropTypes.func.isRequired,
  subTitle: PropTypes.string,
};

export default TechStafferBankerTimeLogHeader;
